import Vue from 'vue'
import VueRouter from 'vue-router'
import GeneralRoutes from '@/router/general'
import ComisionesRoutes from '@/router/comisiones'
import AdminRoutes from '@/router/admin'
import ClienteRoutes from '@/router/cliente'

import CerrarFarmaRoutes from '@/router/cerrarFarma'


Vue.use(VueRouter)

var allRoutes = []

allRoutes = allRoutes.concat(GeneralRoutes, ComisionesRoutes, AdminRoutes, ClienteRoutes, CerrarFarmaRoutes)
const routes = allRoutes
const router = new VueRouter({
  routes,

})

router.beforeEach((to, from, next) => {
// console.log(to);
  if (to.matched.some(record => record.meta.requiresAuth)) {

    let auth = window.sessionStorage.getItem('permisos')  ? JSON.parse(window.sessionStorage.getItem('permisos')).split(',') : 0
    // console.log('at', auth)
    if (!auth) {
      next({
        path: '/',
        // query: { origen: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

router.onError((error) => {
  if (error.name === 'NavigationDuplicated') {
    // Do nothing
  } else {
    console.error(error)
  }
})
export default router
